import { FormGroup } from '@angular/forms';

export function comparisonFactory() {
    return function (group: FormGroup) {
        const tempValue = group.controls['confirmPassword'].value ? null : { noMatch: true };
        return group.controls['newPassword'].setValue(tempValue);
    };
}
